import { render, staticRenderFns } from "./nomination-templates.vue?vue&type=template&id=051cb77e&scoped=true"
import script from "./nomination-templates.vue?vue&type=script&lang=js"
export * from "./nomination-templates.vue?vue&type=script&lang=js"
import style0 from "./nomination-templates.vue?vue&type=style&index=0&id=051cb77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051cb77e",
  null
  
)

export default component.exports